import { GlobalProperties } from '../Types/global';

declare global {
	interface Window extends GlobalProperties {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		portalSettings: any;
	}
}

//TODO: Check if this really works in new react frontend, because it refuses to work in old admin
export const globalProperties: GlobalProperties = {
	...window,
};
